import {graphql, useStaticQuery} from "gatsby";


const useIndexData = () => {
    const data = useStaticQuery(
        graphql`
        query{
            allStrapiCaseStudy(sort: {fields: caseDate, order: DESC}) {
                edges {
                  node {
                    slug
                    pageTitle
                    pageDescription
                    mainImage {
                        url
                    }
                    brandImage {
                      url
                    }
                    caseTitle
                    brandName
                    caseDate(formatString: "MMMM Do, YYYY")
                    mainContent { 
                        data {
                            mainContent
                        }
                    }
                    aboutTheBrand {
                        data {
                            aboutTheBrand
                        }
                    }
                    aboutTheBrandTitle
                    showStats
                    stats {
                        label
                        icon
                        data
                    }
                  }
                }
            }
            strapiFooter {
                columns {
                  title
                  links {
                    text
                    url
                  }
                }
                backgroundShapes {
                    color
                    shapeId
                    side
                }
              }
        }
`);
    return data;
};

export default useIndexData;


